import { render, staticRenderFns } from "./RetailResetPassword.vue?vue&type=template&id=61f93315&scoped=true&lang=pug"
import script from "./RetailResetPassword.vue?vue&type=script&lang=js"
export * from "./RetailResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f93315",
  null
  
)

export default component.exports